/* OK 2026 quick add sheet (the "+" pop-up on product cards), phones only.
   The theme loads the product form into #QuickAddModal (products/<handle>?view=form). On phones this adds
   a header above that form: brand, title, dosage form, rating, swipeable photos (Supplement Facts included),
   price, and a One-time / Subscribe & Save choice. Data comes from /products/<handle>.js, fetched once
   when "+" is tapped. Subscribe & Save adds Shopify's own selling_plan field to the form, the same field the
   product page's ReCharge widget sets, so the cart and checkout treat it the same way.
   Desktop is untouched: nothing here runs above 767px. */
(() => {
  const phone = window.matchMedia('(max-width: 767px)');
  const cache = {};
  const money = cents => '$' + (Number(cents || 0) / 100).toFixed(2);
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const getProduct = handle => {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(() => { delete cache[handle]; return null; });
    }
    return cache[handle];
  };

  /* Dosage form. Same rules as okDosageLabel() in assets/boost-pfs-filter.js and snippets/ok-dosage.liquid. */
  const COUNT_FORMS = ['Capsules', 'Tablets', 'Softgels', 'Chewables', 'Gummies', 'Lozenges', 'Packets'];
  function findForm(text) {
    const t = ' ' + String(text || '').toLowerCase().replace(/[,()\-\/™®&:;]/g, ' ') + ' ';
    const has = k => t.indexOf(k) > -1;
    if (has('softgel') || has('soft gel')) return 'Softgels';
    if (has('vegicap')) return 'Capsules';
    if (has('jelly chew')) return 'Chewables';
    if (has('gummies') || has('gummy')) return 'Gummies';
    if (has('lozenge')) return 'Lozenges';
    if (has('chewable') || has(' chews ')) return 'Chewables';
    if (has('vcap') || has('veg cap') || has('capsule') || has(' caps ')) return 'Capsules';
    if (has('caplet') || has('tablet') || has(' tabs ')) return 'Tablets';
    if (has('packet') || has('stick') || has('sachet')) return 'Packets';
    if (has('spray')) return 'Spray';
    if (has('powder') || has('scoop') || has('drink mix')) return 'Powder';
    if (has('liquid') || has('fl oz') || has('fl. oz') || has(' ml ') || has('drops') || has(' oil ')) return 'Liquid';
    if (has('cream') || has('lotion')) return 'Cream';
    if (has('serum')) return 'Serum';
    return '';
  }
  function formLabel(p, keepIfInTitle) {
    const variants = p.variants || [];
    const vt = variants.filter(v => v.title !== 'Default Title').map(v => ' | ' + v.title).join('');
    const titleForm = findForm(p.title);
    let form = findForm(vt);
    if (!form || (titleForm && COUNT_FORMS.indexOf(form) < 0)) form = titleForm || form;
    if (!form) return '';
    let label = form;
    if (variants.length === 1) {
      const one = String(variants[0].title || '').split(' - ')[0].split('(')[0].trim();
      const w = one.split(' ')[0];
      if (Number(w.replace(/,/g, '')) > 0) {
        const rest = one.slice(w.length).trim();
        if (COUNT_FORMS.indexOf(form) > -1) { if (findForm(rest) === form) label = (w + ' ' + rest).toLowerCase(); }
        else label = form + ' · ' + one.toLowerCase().replace(form.toLowerCase(), '').replace(/\s+/g, ' ').trim().replace(/\.$/, '');
      }
    }
    if (!keepIfInTitle && label === form && titleForm === form) return '';
    return label;
  }
  window.okDosageLabel = formLabel;

  const imgUrl = (src, w) => {
    if (!src) return '';
    const u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };

  // Which card was tapped: start loading its data right away (in parallel with the theme's form request).
  let lastCard = null;
  document.addEventListener('click', e => {
    if (!phone.matches) return;
    const btn = e.target.closest && e.target.closest('.js-modal-open-quick-add, .js-quick-add-form');
    if (!btn) return;
    const card = btn.closest('.grid-product');
    if (!card) return;
    lastCard = card;
    getProduct(card.getAttribute('data-product-handle'));
  }, true);

  document.addEventListener('quickadd:loaded', e => {
    if (!phone.matches) return;
    const handle = e.detail && e.detail.handle;
    const holder = document.getElementById('QuickAddHolder');
    if (!handle || !holder) return;
    const card = lastCard && lastCard.getAttribute('data-product-handle') === handle ? lastCard : document.querySelector('.grid-product[data-product-handle="' + CSS.escape(handle) + '"]');
    getProduct(handle).then(p => build(holder, handle, p, card));
  });

  function build(holder, handle, p, card) {
    const section = holder.querySelector('.product-section[data-product-handle="' + CSS.escape(handle) + '"]');
    if (!section || holder.querySelector('.ok-quick')) return;
    const form = section.querySelector('form[action*="/cart/add"]');
    const select = section.querySelector('select[name="id"]');
    const title = p ? p.title : (section.getAttribute('data-product-title') || '');
    const vendor = p ? p.vendor : '';
    const variants = p ? p.variants : [];
    const url = p ? p.url : '/products/' + handle;

    // Rating from the card the shopper tapped (already on the page).
    let rating = '';
    const badge = card && card.querySelector('.stamped-badge');
    const cap = card && card.querySelector('.stamped-badge-caption');
    const avg = badge ? parseFloat(badge.getAttribute('data-rating')) : 0;
    const count = cap ? parseInt(cap.getAttribute('data-reviews'), 10) : 0;
    if (avg > 0 && count > 0) rating = '<span><span class="ok-quick-stars" aria-hidden="true">★</span> ' + avg.toFixed(1) + ' <span>(' + count + ')</span><span class="visually-hidden"> ' + count + ' reviews</span></span>';

    const form1 = p ? formLabel(p, true) : '';
    const images = p ? (p.media && p.media.length ? p.media.filter(m => m.media_type === 'image').map(m => ({ src: m.src || (m.preview_image && m.preview_image.src), alt: m.alt })) : (p.images || []).map(s => ({ src: s, alt: '' }))) : [];
    const photos = images.slice(0, 8).map((m, i) =>
      '<div class="ok-quick-photo"><img src="' + esc(imgUrl(m.src, 560)) + '" srcset="' + esc(imgUrl(m.src, 360)) + ' 360w, ' + esc(imgUrl(m.src, 560)) + ' 560w" sizes="72vw" alt="' + esc(m.alt || (title + (i ? ' photo ' + (i + 1) : ''))) + '"' + (i ? ' loading="lazy"' : ' fetchpriority="high"') + ' decoding="async" width="560" height="560"></div>').join('');

    // Subscribe & Save, only when every piece of data is there.
    const groups = p && p.selling_plan_groups ? p.selling_plan_groups : [];
    const plans = [];
    // Plan names can carry extra notes (some include a weight range); show just the delivery interval.
    const interval = name => {
      const m = String(name || '').match(/(\d+)\s*(day|week|month)s?/i);
      if (!m) return String(name || '').replace(/\s*\([^)]*\)/g, '').trim();
      const n = +m[1]; const unit = m[2].toLowerCase();
      return n === 1 ? 'Every ' + unit : 'Every ' + n + ' ' + unit + 's';
    };
    const seen = {};
    groups.forEach(g => (g.selling_plans || []).forEach(sp => {
      const label = interval(sp.name);
      if (seen[label]) return; // same interval listed twice (e.g. once per weight range): offer it once
      seen[label] = true;
      plans.push({ id: sp.id, name: label });
    }));
    const hasPlans = !!(form && plans.length && variants.some(v => v.selling_plan_allocations && v.selling_plan_allocations.length));

    const box = document.createElement('div');
    box.className = 'ok-quick';
    box.innerHTML =
      (vendor ? '<span class="ok-quick-brand">' + esc(vendor) + '</span>' : '') +
      '<h2 class="ok-quick-title">' + esc(title) + '</h2>' +
      ((form1 || rating) ? '<div class="ok-quick-meta">' + (form1 ? '<span class="ok-quick-form">' + esc(form1) + '</span>' : '') + rating + '</div>' : '') +
      (photos ? '<div class="ok-quick-photos" tabindex="0" aria-label="Product photos">' + photos + '</div>' : '') +
      (images.length > 1 ? '<p class="ok-quick-photohint">Swipe for more photos, including Supplement Facts.</p>' : '') +
      '<div class="ok-quick-price" aria-live="polite"><b data-okq-price></b><s data-okq-compare></s><em data-okq-save></em></div>' +
      (hasPlans ?
        '<div class="ok-quick-buytype" role="radiogroup" aria-label="Purchase type">' +
          '<button type="button" class="ok-quick-bt" role="radio" aria-checked="true" data-okq-type="one"><span class="ok-quick-dot" aria-hidden="true"></span><span><b>One-time purchase</b><small data-okq-one></small></span></button>' +
          '<button type="button" class="ok-quick-bt" role="radio" aria-checked="false" data-okq-type="sub" tabindex="-1"><span class="ok-quick-dot" aria-hidden="true"></span><span><b>Subscribe &amp; Save</b><small data-okq-sub></small></span></button>' +
        '</div>' +
        '<div class="ok-quick-freq" hidden><label for="OkQuickFreq">Delivery</label><select id="OkQuickFreq">' + plans.map(sp => '<option value="' + esc(sp.id) + '">' + esc(sp.name) + '</option>').join('') + '</select></div>' +
        '<p class="ok-quick-note">Subscriptions: skip or cancel anytime.</p>' : '') +
      (variants.length > 1 ? '<p class="ok-quick-choose">' + (variants.some(v => /\d/.test(v.title)) ? 'Choose a size' : 'Choose an option') + '</p>' : '');
    section.insertBefore(box, section.firstChild);

    const more = document.createElement('a');
    more.className = 'ok-quick-details';
    more.href = url;
    more.textContent = 'See full product details';
    (form && form.parentNode ? form.parentNode : section).appendChild(more);

    const state = { sub: false };
    const current = () => {
      const id = select ? String(select.value) : '';
      return variants.find(v => String(v.id) === id) || variants[0] || null;
    };
    const planId = () => { const f = box.querySelector('#OkQuickFreq'); return f ? f.value : (plans[0] && plans[0].id); };
    const alloc = v => v && v.selling_plan_allocations ? (v.selling_plan_allocations.find(a => String(a.selling_plan_id) === String(planId())) || v.selling_plan_allocations[0]) : null;
    function paint() {
      const v = current();
      if (!v) return;
      const a = alloc(v);
      const sub = state.sub && a && v.available;
      const price = sub ? a.price : v.price;
      const cmp = sub ? v.price : (v.compare_at_price > v.price ? v.compare_at_price : 0);
      box.querySelector('[data-okq-price]').textContent = money(price);
      box.querySelector('[data-okq-compare]').textContent = cmp ? money(cmp) : '';
      const pct = cmp ? Math.round((cmp - price) * 100 / cmp) : 0;
      box.querySelector('[data-okq-save]').textContent = pct > 0 ? 'Save ' + pct + '%' : '';
      const one = box.querySelector('[data-okq-one]');
      const subEl = box.querySelector('[data-okq-sub]');
      if (one) one.textContent = money(v.price);
      if (subEl) {
        if (a) {
          const sp = v.price > 0 ? Math.round((v.price - a.price) * 100 / v.price) : 0;
          subEl.innerHTML = esc(money(a.price)) + (sp > 0 ? ' · <em>save ' + sp + '%</em>' : '');
        } else subEl.textContent = 'Not available for this size';
      }
      // The selling_plan field rides along with the add to cart form only while Subscribe & Save is chosen.
      let input = form && form.querySelector('input[name="selling_plan"][data-okq]');
      if (sub) {
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'selling_plan'; input.setAttribute('data-okq', ''); form.appendChild(input); }
        input.value = a.selling_plan_id;
      } else if (input) input.remove();
    }
    function choose(type) {
      state.sub = type === 'sub';
      box.querySelectorAll('[data-okq-type]').forEach(b => {
        const on = (b.getAttribute('data-okq-type') === 'sub') === state.sub;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      const f = box.querySelector('.ok-quick-freq');
      if (f) f.hidden = !state.sub;
      paint();
    }
    const bt = box.querySelector('.ok-quick-buytype');
    if (bt) {
      bt.addEventListener('click', e => { const b = e.target.closest('[data-okq-type]'); if (b) choose(b.getAttribute('data-okq-type')); });
      bt.addEventListener('keydown', e => {
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
        e.preventDefault();
        choose(state.sub ? 'one' : 'sub');
        const on = bt.querySelector('[aria-checked="true"]'); if (on) on.focus();
      });
      box.querySelector('#OkQuickFreq').addEventListener('change', paint);
    }
    // Size changes: the theme updates the hidden select; repaint after it does.
    section.addEventListener('change', () => setTimeout(paint, 0));
    if (select) select.addEventListener('change', () => setTimeout(paint, 0));
    paint();
  }
})();
